import axios from 'axios';
import {Invoice, Aging, CreditMemo} from '../Invoice/invoice-model';

// const baseURL = "https://localhost:7001/api";
// const baseURL = "https://arportal.azurewebsites.net/api";
//const baseURL = "../api";
const baseURL = "https://ar.kellogggarden.com/api";
const accessKey = process.env.REACT_APP_ACCESS_KEY;
const headerAccess = {
    'Authorization': `Bearer ${accessKey}`,
    'Content-Type': 'application/json'
};

export const fetchLogin =
    async (props) => {
        try {
            const response = await axios.get(`${baseURL}/singIn/authenticate?&userName=${props.email}&password=${encodeURIComponent(props.password)}`);
            const data = response.data;
            return data;
        }
        catch (error) {
            console.error(error);
            return ['error'];
            throw new Error('Failed to fetch login data');
        }
    };

export const fetchSignup =
async (props) => {
    try {
        // const response = await axios.get(`${baseURL}/singIn/signUp?&customer=${props.customerNumber}&userName=${props.email}&password=${props.password}&warehouse=${props.warehouse}`);
        const response = await axios.get(`${baseURL}/singIn/signUp?&customer=${props.customerNumber}&userName=${props.email}&password=${encodeURIComponent(props.password)}`);
        const data = response.data;
        return data;
    }
    catch (error) {
        console.error(error);
        return ['error'];
        throw new Error('Failed to fetch login data');
    }
};

export const fetchResetPasswordLink =
    async (email) => {
        try {
            const response = await axios.get(`${baseURL}/singIn/resetPasswordLink?&email=${email}`);
            const data = response.data;
            return data;
        }
        catch (error) {
            console.error(error);
            return ['error'];
            throw new Error('Failed to fetch login data');
        }
    };

export const fetchResetPassword =
async (password, guid) => {
    try {
        const response = await axios.get(`${baseURL}/singIn/ResetPassword?&password=${encodeURIComponent(password)}&guid=${guid}`);
        const data = response.data;
        return data;
    }
    catch (error) {
        console.error(error);
        return ['error'];
        throw new Error('Failed to fetch login data');
    }
};

export const fetchGetContacts =
    async (email, site) => {
        try {
            const response = await axios.get(`${baseURL}/singIn/getContacts?&userName=${email}&site=${site}`);
            const data = response.data;
            return data;
        }
        catch (error) {
            console.error(error);
            return ['error'];
            throw new Error('Failed to fetch login data');
        }
    };

// export const fetchInvoice =
// async (props) => {
//     try {
//         let data={};
//         const lastUpdateResponse = await axios.get(`${baseURL}/invoice/getLastUpdatedDate`);
//         data.lastUpdate = lastUpdateResponse.data;
//         const invoiceResponse = await axios.get(`${baseURL}/invoice/getInvoiceLog?page=${props.page}&size=${props.size}&customerNumber=${encodeURIComponent(props.customerNumber)}&sort=${props.sort}&direction=${props.direction}&status=${props.status}&searchText=${props.search}`);
//         data.invoiceData = invoiceResponse.data.invoiceLogs.map(obj => new Invoice(obj).state);
//         data.total = invoiceResponse.data.total;
//         data.totalInvoiceAmount = invoiceResponse.data.totalInvoiceAmount;
//         data.totalPaidAmount = invoiceResponse.data.totalPaidAmount;
//         const agingResponse = await axios.get(`${baseURL}/invoice/getAging?customerNumber=${props.customerNumber}&status=${props.status}&search=${props.search}`);
//         data.agingData = new Aging(agingResponse.data).state;
//         const creditMemoResponse = await axios.get(`${baseURL}/invoice/getCreditMemo?warehouse=${props.warehouse}&custNum=${props.custNum}`);
//         //const creditMemoResponse = await axios.get(`${baseURL}/invoice/getCreditMemo?warehouse=${props.warehouse}&custNum=9900532`);
//         data.creditMemoData = creditMemoResponse.data.map(obj => new CreditMemo(obj).state);
//         return data;
//     }
//     catch (error) {
//         console.error(error);
//         return ['error'];
//         throw new Error('Failed to fetch invoice data');
//     }
// };    

export const fetchInvoice =
async (props) => {
    try {
        let data={};
        const lastUpdateResponse = await axios.get(`${baseURL}/invoice/getLastUpdatedDate`);
        data.lastUpdate = lastUpdateResponse.data;
        const invoiceResponse = await axios.post(`${baseURL}/invoice/GetInvoiceLogs?page=${props.page}&size=${props.size}&sort=${props.sort}&direction=${props.direction}&status=${props.status}&searchText=${encodeURIComponent(props.search)}`, {Customers: props.customerNumber});
        data.invoiceData = invoiceResponse.data.invoiceLogs.map(obj => new Invoice(obj).state);
        data.total = invoiceResponse.data.total;
        data.totalInvoiceAmount = invoiceResponse.data.totalInvoiceAmount;
        data.totalPaidAmount = invoiceResponse.data.totalPaidAmount;
        const agingResponse = await axios.post(`${baseURL}/invoice/getAging?status=${props.status}&search=${encodeURIComponent(props.search)}`, {Customers: props.customerNumber});
        data.agingData = new Aging(agingResponse.data).state;
        console.log(props.custNum);
        // const creditMemoResponse = await axios.get(`${baseURL}/invoice/getCreditMemo?warehouse=${props.warehouse}&custNum=${props.custNum}`);
        const creditMemoResponse = await axios.post(`${baseURL}/invoice/getCreditMemo?warehouse=${props.warehouse}`, {Customers: props.custNum.toString()});
        data.creditMemoData = creditMemoResponse.data.map(obj => new CreditMemo(obj).state);
        return data;
    }
    catch (error) {
        console.error(error);
        return ['error'];
        throw new Error('Failed to fetch invoice data');
    }
};    

export const fetchInvoicePDF =
async (props) => {
    try {
        const response = await axios.get(`${baseURL}/invoice/getInvoicePDF?guid=${props.guid}`, {responseType:'blob'});
        const blob = new Blob([response.data], {
            type: 'application/pdf'
        });
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
        const data = response.data;
        return data;
    }
    catch (error) {
        console.error(error);
        return ['error'];
        throw new Error('Failed to fetch login data');
    }
};    

export const fetchPODPDF =
async (props) => {
    try {
        const response = await axios.get(`${baseURL}/invoice/getPOD?shipmentId=${props.shipmentId}`, {responseType:'blob'});
        const blob = new Blob([response.data], {
            type: 'application/pdf'
        });
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
        const data = response.data;
        return data;
    }
    catch (error) {
        console.error(error);
        return ['error'];
        throw new Error('Failed to fetch login data');
    }
};  

export const fetchStatement =
async (props) => {
    try {
        // console.log("Pick Work API Hit");
        // let filter = encodeURIComponent(props.filter);
        // const response = await axios.get(`${baseURL}/pick/?warehouse=${props.warehouse}&filter=${filter}&sort=${props.sort}`);
        // const data = response.data.map(obj => new PickWorkbench(obj).state);
        // return data;
    }
    catch (error) {
        console.error(error);
        return ['error'];
        throw new Error('Failed to fetch statement data');
    }
};    